<template>
  <v-dialog
    fullscreen
    hide-overlay 
    v-if="email || dialog"
    v-model.sync="mDialog"
  >
    <v-card>
      <v-toolbar>
        <v-btn icon @click="mDialog = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Nova mensagem de email</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-alert :value="true" type="warning" v-if="schedule === 5">Este email será disparado assim que for cadastrado</v-alert>
        <v-alert :value="true" type="warning" v-if="schedule === 6">Este email será disparado ao cliente no momento do pedido</v-alert>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          method="post"
          @submit="submit"
        >        
          <v-row>
            <v-col xs="12" md="4">
              <v-text-field 
                :autofocus="true"
                :rules="senderRules" 
                required
                type="email"
                v-model="sender" 
                label="Remetente"
                :counter="250"
              ></v-text-field>
            </v-col>
            <v-col xs="12" md="4">
              <v-text-field               
                :rules="titleRules" 
                required 
                v-model="title" 
                label="Título da mensagem"
                :counter="250"
              ></v-text-field>
            </v-col>
            <v-col xs="12" md="4">
              <v-select
                v-model="schedule"
                :items="[
                  {
                    text: 'Diariamente',
                    value: 1,
                  },
                  {
                    text: 'Mensalmente',
                    value: 2,
                  },
                  {
                    text: 'Selecionar data para envio',
                    value: 3,
                  },
                  {
                    text: '# dias após data do pedido',
                    value: 4,
                  },
                  {
                    text: 'Enviar imediatamente ao salvar',
                    value: 5,
                  },
                  {
                    text: 'Enviar no momento do pedido',
                    value: 6,
                  },
                ]"
                label="Agendar envio"
                required
                @change="changeSchedule"
                :rules="scheduleRules"              
              ></v-select>
            </v-col>
            <v-col xs="12" md="4" v-if="schedule === 4">
              <v-text-field               
                :rules="schedule_daysRules" 
                required 
                v-model="schedule_days" 
                label="Número de dias após inicio da transação"
                minlenght="1"
                min="1"
                type="number"
                :counter="250"
              ></v-text-field>
            </v-col>
            <v-col xs="12" md="4" v-if="schedule === 3">
              <v-menu
                v-if="schedule === 3"
                v-model="schedule_date_menu"
                :close-on-content-click="false"
                full-width
                max-width="290"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="schedule_date_formated"
                    clearable
                    label="Data de envio"
                    @click:clear="clear_schedule_date"
                    readonly
                    :required="schedule === 3"
                    prepend-icon="event"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="schedule_date"
                  @change="schedule_date_menu = false"                
                  locale="pt-br"
                ></v-date-picker>
              </v-menu>            
            </v-col>
            <v-col xs="12" md="4">
              <v-select
                v-model="lead_segments"
                :items="$store.state.leadSegmentations.map(s => {
                  return {text: s.name, value: s.id}
                })"
                label="Destinatários"
                required
                :rules="arrayRequired"
                @input="resetValidation"
                chips
                multiple
              ></v-select>
            </v-col>
            <v-col xs="12" md="4">
              <v-switch v-if="this.schedule !== 5" v-model="active" label="Ativo"></v-switch>
            </v-col>
            <v-col xs="12">
              <label for="email-content">Lista de tags: </label>
              <div>
                <v-chip v-for="t in tags" :key="t.id">{{t}}</v-chip>
              </div>
              <label for="email-content">Corpo da Mensagem</label>
              <Editor id="email-content" :initialContent="content" @contentChanged="onContentChange"/>
              <v-text-field                             
                required
                v-model="content"
                type="hidden"
              ></v-text-field>
            </v-col>


            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="default"
                @click="reset"
              >
                Limpar formulário
              </v-btn>
              <v-btn
                :disabled="!valid"
                color="success"
                type="submit"          
              >
                {{this.editEmail ? 'Atualizar' : 'Cadastrar'}}
              </v-btn>
            </v-card-actions>
          </v-row>        
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>  
</template>

<script>
  import Editor from './Editor';
  import moment from 'moment';
  export default {
    components: {
      Editor
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      editEmail: {
        type: Object,
        default: null
      }
    },
    name: 'Create',    
    created() {
      this.$store.dispatch('fetchLeadSegmentations');
    },
    data () {
      return {
        sender: (this.editEmail && this.editEmail.sender) || '',
        title: (this.editEmail && this.editEmail.title) || '',
        schedule: (this.editEmail && this.editEmail.schedule) || '',
        content: (this.editEmail && this.editEmail.content) ||'',
        schedule_date: (this.editEmail && this.editEmail.schedule_date) || null,
        schedule_days: (this.editEmail && this.editEmail.schedule_days) || null,
        active: (this.editEmail && this.editEmail.active) || false,
        lead_segments: (this.editEmail && this.editEmail.lead_segments.map(ls => ls.id)) || [],
        schedule_date_menu: false,
        valid: false,
        email: this.editEmail || null,
        senderRules: [
          v => !!v || 'Campo obrigatório',
        ],
        titleRules: [
          v => !!v || 'Campo obrigatório',
        ],
        scheduleRules: [
          v => !!v || 'Campo obrigatório',
        ],
        arrayRequired: [
          v => v && v.length > 0 || 'Escolha um item da lista'
        ],
        tags: [
          '#nome',
          '#cpf',
          '#telefone',
          '#cep',
          '#endereco',
          '#bairro',
          '#cidade',
          '#estado',
          '#boletolink',
          '#boletodigitos',
          '#preco',
          '#vencimentoboleto',
          '#codigorastreamento'
        ]
      }
    },
    computed: {
      schedule_date_formated () {
        return this.dateFormattedMomentjs(this.schedule_date);
      },
      mDialog: {
        get() {
          return this.dialog;
        },
        set(value) {          
          this.$emit('closeDialog');
        }
      },
    },
    methods: {
      onContentChange(content) {
        this.content = content;
      },
      clear_schedule_date () {
        this.schedule_date = null;
      },
      dateFormattedMomentjs (date) {
        return date ? moment(date).format('DD/MM/YYYY') : ''
      },
      changeSchedule() {
        if (this.schedule === 3) {
          this.schedule_date_menu = true;
        }
      },
      submit(e) {
        e.preventDefault();      
        if (this.$refs.form.validate()) {
          const form = {
            data: {
              sender: this.sender,
              title: this.title,
              schedule: this.schedule,
              content: this.content,
              lead_segments: this.lead_segments,
              active: this.active
            }            
          }
          if (this.schedule === 3) {
            form.data.schedule_date = this.schedule_date;
          }
          if (this.schedule === 4) {
            form.data.schedule_days = this.schedule_days;
          }
          if (this.editEmail) {
            form.data.id = this.editEmail.id;
          }
          this.$store.dispatch('createEmail', form);
          if (!this.editEmail) {
            this.reset();
          }
        }
      },
      validate () {
        return this.$refs.form.validate();
      },
      reset () {
        this.$refs.form.reset();
        this.content = ""
      },
      resetValidation () {
        this.$refs.form.resetValidation();
      },
    }
  }
</script>